import { Component, computed, inject } from '@angular/core';
import { UIIconComponent } from '@design-system';
import { IconName, IconNames } from '@assets/icons';
import { ConnectionNotice, ConnectionStateService } from '../../services/connection-state.service';

const NOTICE_STYLE: Record<Exclude<ConnectionNotice, 'hidden'>, { colorClass: string; icon: IconNames }> = {
	connecting: { colorClass: 'bg-yellow-500', icon: IconName.LsConnecting },
	connected: { colorClass: 'bg-green-500', icon: IconName.LsConnect },
	disconnected: { colorClass: 'bg-red-500', icon: IconName.LsNotConnect },
	offline: { colorClass: 'bg-red-500', icon: IconName.LsNotConnect }
};

@Component({
	selector: 'connection-state',
	imports: [UIIconComponent],
	templateUrl: './connection-state.component.html'
})
export class ConnectionStateComponent {
	protected readonly connectionState = inject(ConnectionStateService);

	readonly visible = computed(() => this.connectionState.notice() !== 'hidden');

	readonly colorClass = computed(() => this.style().colorClass);

	readonly iconName = computed(() => this.style().icon);

	private readonly style = computed(() => {
		const notice = this.connectionState.notice();
		return notice === 'hidden' ? NOTICE_STYLE.disconnected : NOTICE_STYLE[notice];
	});
}
